import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  InitialPromotionBody,
  InitiatePromotionPageHeader,
} from "./components";

import { usePromotion } from "@hooks/HRM/promotions/usePromotion";
import { useUser } from "@hooks/useUser";

import { PROMOTION_STATUS } from "@constants/status.hrm";

const { DRAFT } = PROMOTION_STATUS;

const InitiatePromotion = () => {
  const { id } = useParams();
  const {
    data: promotionData,
    handleUpdate: handlePromotionUpdate,
    handleDelete: handlePromotionDelete,
    handleRecommendation: handlePromotionRecommendation,
    handleUpdatePromotionGroup,
  } = usePromotion(id as string);

  const {
    user: { employeeMasterId, realm_roles: roles },
  } = useUser();

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [showActionButton, setShowActionButton] = useState<boolean>(false);
  const canUpdatePromotion = roles.includes("f_per_all_promotion");

  useEffect(() => {
    setIsDisabled(!(promotionData.status === DRAFT && canUpdatePromotion));
    setShowActionButton(
      Number(promotionData.nextReviewerId) === Number(employeeMasterId),
    );
  }, [promotionData, employeeMasterId]);

  return (
    <>
      {!isDisabled && <InitiatePromotionPageHeader />}
      <InitialPromotionBody
        promotionId={id as string}
        employeeMasterId={employeeMasterId}
        promotionData={promotionData}
        isDisabled={isDisabled}
        showActionButton={showActionButton}
        handlePromotionDelete={handlePromotionDelete}
        handlePromotionUpdate={handlePromotionUpdate}
        handlePromotionRecommendation={handlePromotionRecommendation}
        handleUpdatePromotionGroup={handleUpdatePromotionGroup}
      />
    </>
  );
};

export default InitiatePromotion;
